import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './Common.css';

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, type = 'danger' }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay confirm-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
            <div className="modal confirm-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="confirm-header">
                    <AlertTriangle className={`confirm-icon icon-${type}`} size={32} />
                    <h3>{title}</h3>
                </div>
                <p className="confirm-message">{message}</p>
                <div className="confirm-actions">
                    <button className="btn-secondary" onClick={onCancel}>Cancelar</button>
                    <button className={`btn-primary btn-${type}`} onClick={onConfirm}>
                        {type === 'danger' ? 'Eliminar' : 'Confirmar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
